import axiosInstance from "../../utils/AxiosInstance";

export const getJob = async (id) => {
  const response = await axiosInstance.get(`/jobs/${id}`);
  return response.data;
};
